var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseView',[_c('template',{slot:"status"},[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('Blacklisted')))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }